// BSL-SAT §4 — Satış ve tahsilat turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
// devam: tur sürerken kullanıcı o turun sayfasına geçerse (ör. Detay → Ödeme Al) sonraki tur başlar.
export default {
  urunSatis: {
    yol: "/islemler/satis",
    adimlar: [
      { hedef: '[data-tur="satis-musteri"]', metin: "Satışı kime yaptığınızı seçin; listede yoksa «+ Yeni müşteri» ile buradan ekleyin." },
      { hedef: '[data-tur="satis-urun"]', metin: "Ürüne dokununca sepete girer. Aramayla ya da kategori düğmeleriyle bulun." },
      { hedef: '[data-tur="satis-alinan"]', metin: "Alınan ücret toplamdan azsa kalanı müşterinin borcuna yazılır. Yöntem, alınan kısmın nasıl ödendiği.", kavram: "alinanUcret" },
      // RH-2: düğme yalnız hizmet hakkı açan satıştan sonra çıkan pencerede; yoksa balon atlanır
      { hedef: '[data-tur="satis-randevu"]', metin: "Hizmet sattıysanız fiş sonunda «Randevu planla» ile hemen takvime geçin.", kavram: "hizmetHakki" },
    ],
  },
  musteriHesap: {
    yol: "/musteri/borclumusteri",
    devam: "odemeAl",
    adimlar: [
      { hedef: '[data-tur="hesap-liste"]', metin: "Borcu olan müşteriler burada; tutar, ödenmemiş satışların toplamı.", kavram: "borcluMusteri" },
      // BSL-D3 (B-13): Detay düğmesi = satırın son hücresi (tablo) / düğme sütunu (kart); MusteriAd'daki AI düğmesi değil.
      { hedef: ['[data-tur="hesap-liste"] .p-datatable-tbody tr:first-child td:last-child button', '[data-tur="hesap-liste"] [data-kart-satir] > div:last-child button[aria-label="Düzenle"]'], metin: "Detay, müşterinin Ödeme Al ekranını açar." },
    ],
  },
  odemeAl: {
    yol: "/islemler/odemeal",
    adimlar: [
      { hedef: '[data-tur="odeme-tip"]', metin: "Borca ödeme açık borçtan düşer. Ön ödeme bakiyeye yazılır, sonraki satışlarda kendiliğinden düşülür.", kavram: "bakiye" },
      { hedef: '[data-tur="odeme-tutar"]', metin: "Tutarı ve yöntemi girin; «Tümünü öde» kalan borcun tamamını yazar." },
      { hedef: '[data-tur="odeme-tahsil"]', metin: "Tahsil edince borç düşer ve kasa raporlarına girer." },
    ],
  },
  satisIptal: {
    yol: "/islemler/satisiptal",
    adimlar: [
      { hedef: '[data-tur="iptal-fis"]', metin: "Satışı fiş numarasıyla ya da müşteriyle bulun." },
      { hedef: '[data-tur="iptal-satir"]', metin: "Satışın tamamını iptal edin ya da bir kısmını iade edin (ürün ve hizmette)." },
      // BSL-D3 (B-14): sebep alanı İptal'e tıklayınca açılan pencerede — balon onu bekler.
      { hedef: '[data-tur="iptal-sebep"]', bekle: true, metin: "Sebep zorunlu. İptal para iade etmez; ödenmiş kısım müşterinin bakiyesine geçer.", kavram: "iptalIade" },
    ],
  },
};
